import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './article-page-video-carousel-item.component.scss';
import * as $ from 'jquery';
var ArticlePageVideoCarouselItem = /** @class */ (function (_super) {
    tslib_1.__extends(ArticlePageVideoCarouselItem, _super);
    function ArticlePageVideoCarouselItem(element) {
        return _super.call(this, element) || this;
    }
    ArticlePageVideoCarouselItem.prototype.init = function () {
        this.playButton = this.element.querySelector('.js-video-play');
        this.closeButton = this.element.querySelector('.js-video-close');
        this.playerContainer = this.element.querySelector('.article-page-video-carousel-item__container');
        this.playerContent = this.element.querySelector('.article-page-video-carousel-item__playercontent');
        this.playerTimeContainer = this.element.querySelector('.article-page-video-carousell-item__time-placeholder');
        this.player = this.playerContainer.querySelector('.ot-video-containingBlock');
        this.video = this.element.querySelector('video');
        this.isExternal = false;
        if (!this.element.querySelector('picture')) {
            this.showVideoNoImage(this.playButton);
        }
        else {
            if (this.element.querySelector('.responsive-image')) {
                var imgTag = this.element.querySelector('.responsive-image');
                if (!imgTag.getAttribute('src')) {
                    this.showVideoNoImage(this.playButton);
                }
                else {
                    if (imgTag.getAttribute('src') !== '') {
                        this.showVideoNoImage(this.playButton);
                    }
                }
            }
        }
    };
    ArticlePageVideoCarouselItem.prototype.bindEvents = function () {
        var _this = this;
        this.playButton.addEventListener('click', function (event) { return _this.showVideo(event); });
        this.closeButton.addEventListener('click', function (event) { return _this.hideVideo(event); });
        this.renderTime();
    };
    ArticlePageVideoCarouselItem.prototype.showVideo = function (event) {
        event.preventDefault;
        this.hideActiveVideo(event);
        this.playerContainer.classList.add('article-page-video-carousel-item__container--playing');
        if (event.currentTarget.hasAttribute('data-youtube-id')) {
            this.isExternal = true;
            var videoExternal = event.currentTarget;
            var getVideo = videoExternal.getAttribute('data-youtube-id');
            this.createIframePlayer(getVideo);
            this.analyticsService.dtmVideoTrackerAutoSpot();
        }
        else if (event.currentTarget.hasAttribute('data-video-file')) {
            this.isExternal = true;
            var videoExternal = event.currentTarget;
            this.element.classList.add('video--playing');
            var getVideo = videoExternal.getAttribute('data-video-file');
            this.createHTML5Player(getVideo);
        }
        else {
            this.video.player.play();
        }
    };
    ArticlePageVideoCarouselItem.prototype.hideVideo = function (event) {
        event.preventDefault;
        var removeIframe = this.playerContent.querySelector('iframe');
        this.playerContainer.classList.remove('article-page-video-carousel-item__container--playing');
        if (removeIframe) {
            this.playerContent.removeChild(removeIframe);
        }
        else {
            // this.video.player.pause();
        }
    };
    ArticlePageVideoCarouselItem.prototype.hideActiveVideo = function (event) {
        var selectedVideo = event.target;
        if (!selectedVideo.classList.contains('article-page-video-carousel-item__container--playing')) {
            var videoContainers = Array.from(document.querySelectorAll('.article-page-video-carousel-item__container--playing'));
            videoContainers.map(function (itemContainer) {
                itemContainer.classList.remove('article-page-video-carousel-item__container--playing');
                var iframeExistence = itemContainer.querySelector('iframe');
                if (iframeExistence) {
                    var iframeChildren = $(itemContainer).find('iframe');
                    iframeChildren.remove();
                }
                else {
                    var videoChildren = itemContainer.querySelector('video');
                    var playerChildren = itemContainer.querySelector('.ot-video-containingBlock');
                }
            });
        }
    };
    ArticlePageVideoCarouselItem.prototype.createIframePlayer = function (url) {
        var externalUrl = 'https://www.youtube.com/embed/';
        externalUrl += url;
        externalUrl += '?rel=0&amp;showinfo=0&autoplay=1&enablejsapi=1';
        var createIframe = document.createElement('iframe');
        createIframe.id = 'video__external';
        createIframe.src = externalUrl;
        createIframe.classList.add('video__iframe');
        createIframe.setAttribute('allowfullscreen', 'true');
        this.playerContent.appendChild(createIframe);
    };
    ArticlePageVideoCarouselItem.prototype.createHTML5Player = function (url) {
        // this.playerContent.style.height = '100%';
        // this.playerContainer.style.opacity = '1';
        // this.playerContainer.style.visibility = 'visible';
        // this.playerContainer.style.display = 'none';
        // this.playerContainer.style.height = '100%';
        var externalUrl = url;
        var createIframe = document.createElement('iframe');
        createIframe.id = 'video__external';
        createIframe.src = externalUrl;
        createIframe.setAttribute('allowfullscreen', 'true');
        createIframe.classList.add('video__iframe');
        this.playerContent.appendChild(createIframe);
    };
    ArticlePageVideoCarouselItem.prototype.renderTime = function () {
        if (this.playButton.hasAttribute('data-youtube-id')) {
            // let videoTimePlaceholder: any = this.playerTimeContainer;
            // let getVideo = this.playButton.getAttribute('data-youtube-id');
            // axios.get('https://www.googleapis.com/youtube/v3/videos?part=contentDetails&id='+getVideo+'&key=AIzaSyBcaoVc-sCwi_7txKMV9BEUhDf4yrcq384', { responseType: 'json' }).then(function(response: any) {
            // 	let object: any = response.data.items[0].contentDetails.duration;
            // 	let array: any = object.match(/(\d+)(?=[MHS])/ig)||[]; 
            // 	let formatted: any = array.map(function(item){
            // 		if(item.length<2) return '0'+item;
            // 		return item;
            // 	}).join(':');
            // 	if(formatted){
            // 		videoTimePlaceholder.innerHTML = formatted;
            // 	}else{
            // 		videoTimePlaceholder.innerHTML = '00:00:00';
            // 	}
            // }).catch(function(response) {
            // 	console.log(response);
            // });
        }
    };
    ArticlePageVideoCarouselItem.prototype.createHTML5PlayerInit = function (url) {
        this.playerContent.style.height = '100%';
        this.playerContainer.style.opacity = '1';
        this.playerContainer.style.visibility = 'visible';
        this.playerContainer.style.height = '100%';
        var externalUrl = url;
        var createIframe = document.createElement('iframe');
        createIframe.id = 'video__external';
        createIframe.src = externalUrl;
        createIframe.setAttribute('allowfullscreen', 'true');
        createIframe.classList.add('video__iframe');
        this.playerContent.appendChild(createIframe);
    };
    ArticlePageVideoCarouselItem.prototype.createIframePlayerInit = function (url) {
        this.playerContent.style.height = '100%';
        this.playerContainer.style.opacity = '1';
        this.playerContainer.style.visibility = 'visible';
        this.playerContainer.style.height = '100%';
        var externalUrl = 'https://www.youtube.com/embed/';
        externalUrl += url;
        externalUrl += '?rel=0&amp;showinfo=0&enablejsapi=1';
        var createIframe = document.createElement('iframe');
        createIframe.id = 'video__external';
        createIframe.src = externalUrl;
        createIframe.setAttribute('allowfullscreen', 'true');
        createIframe.classList.add('video__iframe');
        this.playerContent.appendChild(createIframe);
    };
    ArticlePageVideoCarouselItem.prototype.showVideoNoImage = function (element) {
        this.closeButton.classList.add('d-none');
        this.playerContainer.classList.add('article-page-video-carousel-item__container--playing');
        if (element.hasAttribute('data-youtube-id')) {
            this.isExternal = true;
            var videoExternal = element;
            var getVideo = videoExternal.getAttribute('data-youtube-id');
            this.createIframePlayerInit(getVideo);
            this.analyticsService.dtmVideoTrackerAutoSpot();
        }
        else if (element.hasAttribute('data-video-file')) {
            this.isExternal = true;
            var videoExternal = element;
            var getVideo = videoExternal.getAttribute('data-video-file');
            this.createHTML5PlayerInit(getVideo);
        }
    };
    return ArticlePageVideoCarouselItem;
}(Base));
export { ArticlePageVideoCarouselItem };



//////////////////
// WEBPACK FOOTER
// ./components/article-page-video-carousel-item/article-page-video-carousel-item.component.ts
// module id = 110
// module chunks = 0